export default __webpack_public_path__ + "static/media/niski ig-1.683a74f7.png";